import { post } from "@/utils/utils";

const merchants = {
  state: {
    storeBasucList: {},
    storeShopInfoList: {},
    supplierBrandGuiderList: {},
    detailsGuiderInfo: {
      guiderInfo: {
        workCardImg: "",
        outletImg: ""
      }
    },
    auditCount: {},
    queryDictItems: {},
    supplierReceiptList: {}
  },
  mutations: {
    QUERY_STORE_BASIC_LIST(state, data) {
      state.storeBasucList = data.result;
    },
    QUERY_STORE_SHOP_INFO_LIST(state, data) {
      state.storeShopInfoList = data.result;
    },
    SAVE_STORE_SHOP_INFO(state, data) {
      state.saveStoreShopInfo = data.result;
    },
    DETAILS_STORE_SHOP_INFO(state, data) {
      state.detailsStoreShopInfo = data.result;
    },
    EDIT_STORE_SHOP_INFO(state, data) {
      state.editStoreShopInfo = data.result;
    },
    BATCH_EDIT_ENABLED_STATE(){},
    DEL_STORE_SHOP_INFO(state, data) {
      state.delStoreShopInfo = data.result;
    },
    queryStoreBasuc(state) {
      state.storeBasucList = {};
    },
    QUERY_SUPPLIER_BRAND_GUIDER_LIST(state, data) {
      state.supplierBrandGuiderList = data.result;
    },
    DETAILS_GUIDER_INFO(state, data) {
      state.detailsGuiderInfo = data.result;
    },
    AUDIT_GUIDER_INFO(state, data) {
      state.auditGuiderInfo = data.result;
    },
    AUDIT_COUNT(state, data) {
      state.auditCount = data.result;
    },
    QUERY_DICT_ITEMS(state, data) {
      state.queryDictItems = data.result;
    },
    DETAILS_OCR_RULE(state, data) {
      state.detailsOcrRule = data.result;
    },
    ADD_OCR_RULE(state, data) {
      state.addOcrRule = data.result;
    },
    QUERY_OCR_RESULT(state, data) {
      state.ocrResult = data.result;
    },
    QUERY_OCR_IMG_LIST() {},
    QUERY_STORE_REWARD_LIST() {},
    SUBMIT_DECLARE_IMG() {},
    QUERY_STORE_BASIC_LIST_COMBO_BOX() {},
    QUERY_STORE_SHOP_INFO_LIST_NEW() {},
    EDIT_STORE_NAME() {},
    EDIT_SUPPLIER_ACCOUNT_TYPE() {},
    QUERY_AGENCY_SHOP_LIST() {},
    QUERY_AGENCY_NOT_REL_SHOP_LIST() {},
    AGENCY_SHOP_DEL() {},
    AGENCY_SHOP_SAVE() {},
    QUERY_AGENCY_REL_SHOP_LIST_BOX() {},
    QUERY_SUPPLIER_RECEIPT_LIST(state, data) {
      state.supplierReceiptList = data.result;
    },
    ADD_SUPPLIER_RECEIPT() {},
    EDIT_SUPPLIER_RECEIPT() {},
    QUERY_BY_ID_SUPPLIER_RECEIPT() {},
    FIND_STORE_PAGE_BY_TYPE() {},
    QUERY_SHOP_BRAND_TYPE() {},
    QUERY_STORE_CODEPAGE() {},
    QUERY_STORE_SHOP_INFO_LISTS() {},
    QUERY_STORE_SHOP_INFO_LIST_NEW(){},
    OPERATE_BATCH() {},
    QUERY_STORE_SHOP_INFO_LISTII(){}
  },
  actions: {
    queryStoreBasicList({ commit }, params) {
      return post({
        commit,
        url: `/storeBasicInfo/findStoreBasicInfoList`,
        name: "QUERY_STORE_BASIC_LIST",
        params
      });
    },
    queryStoreCodePage({ commit }, params) {
      return post({
        commit,
        url: `/store/supplierWindowMessageInfo/detailStoreCodePage`,
        name: "QUERY_STORE_CODEPAGE",
        params
      });
    },
    queryStoreBasicListComboBox({ commit }, params) {
      return post({
        commit,
        url: `/storeBasicInfo/findStoreBasicInfoListComboBox?false`,
        name: "QUERY_STORE_BASIC_LIST_COMBO_BOX",
        params
      });
    },
    queryStoreShopInfoList({ commit }, params) {
      return post({
        commit,
        url: `/storeBasicInfo/findStoreShopInfoList`,
        name: "QUERY_STORE_SHOP_INFO_LIST",
        params
      });
    },
    queryStoreShopInfoListIi({ commit }, params) {
      return post({
        commit,
        url: `/storeBasicInfo/findStoreShopInfoList`,
        name: "QUERY_STORE_SHOP_INFO_LISTII",
        params
      });
    },
    queryStoreShopInfoLists({ commit }, params) {
      return post({
        commit,
        url: `/storeBasicInfo/findOnlyStoreShopInfoPageList`,
        name: "QUERY_STORE_SHOP_INFO_LISTS",
        params
      });
    },
    operateBatch({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/guider_declare/operateBatch`,
        name: "OPERATE_BATCH",
        params
      });
    },
    
    saveStoreShopInfo({ commit }, params) {
      return post({
        commit,
        url: `/storeBasicInfo/saveStoreShopInfo`,
        name: "SAVE_STORE_SHOP_INFO",
        params
      });
    },
    detailsStoreShopInfo({ commit }, params) {
      return post({
        commit,
        url: `/storeBasicInfo/findStoreShopInfoById`,
        name: "DETAILS_STORE_SHOP_INFO",
        params
      });
    },
    editStoreShopInfo({ commit }, params) {
      return post({
        commit,
        url: `/storeBasicInfo/editStoreShopInfo`,
        name: "EDIT_STORE_SHOP_INFO",
        params
      });
    },
    batchEditEnabledState({ commit }, params) {
      return post({
        commit,
        url: `/storeBasicInfo/batchEditEnabledState`,
        name: "BATCH_EDIT_ENABLED_STATE",
        params
      });
    },
    queryShopBrandType({ commit }, params) {
      return post({
        commit,
        url: `/sys/common/dict_items?dictCode=supplier_shop_attr_type_brand`,
        name: "QUERY_SHOP_BRAND_TYPE",
        params
      });
    },
    delStoreShopInfo({ commit }, params) {
      return post({
        commit,
        url: `/storeBasicInfo/delStoreShopInfo`,
        name: "DEL_STORE_SHOP_INFO",
        params
      });
    },
    queryGuiderAndShopNameList({ commit }, params) {
      return post({
        commit,
        url: `/storeBasicInfo/queryGuiderAndShopNameList`,
        name: "QUERY_STORE_SHOP_INFO_LIST_NEW",
        params
      });
    },
    
    querySupplierBrandGuiderList({ commit }, params) {
      return post({
        commit,
        url: `/supplierBrandGuiderRel/findSupplierBrandGuiderRelList`,
        name: "QUERY_SUPPLIER_BRAND_GUIDER_LIST",
        params
      });
    },
    detailsGuiderInfo({ commit }, params) {
      return post({
        commit,
        url: `/supplierBrandGuiderRel/findGuiderInfo`,
        name: "DETAILS_GUIDER_INFO",
        params
      });
    },
    auditGuiderInfo({ commit }, params) {
      return post({
        commit,
        url: `/supplierBrandGuiderRel/auditSupplierBrandGuiderRel`,
        name: "AUDIT_GUIDER_INFO",
        params
      });
    },
    auditRelStateCount({ commit }, params) {
      return post({
        commit,
        url: `/supplierBrandGuiderRel/findSupplierBrandGuiderRelStateCount`,
        name: "AUDIT_COUNT",
        params
      });
    },
    queryDictItems({ commit }, params) {
      return post({
        commit,
        url: `/sys/common/dict_items?dictCode=date_model`,
        name: "QUERY_DICT_ITEMS",
        params
      });
    },
    detailsOcrRule({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/receipt_sn_template/detail`,
        name: "DETAILS_OCR_RULE",
        params
      });
    },
    addOcrRule({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/receipt_sn_template/add`,
        name: "ADD_OCR_RULE",
        params
      });
    },
    queryOcrResult({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/receipt_sn_template/ocr_result`,
        name: "QUERY_OCR_RESULT",
        params
      });
    },
    queryOcrImgList({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/receipt_img/list`,
        name: "QUERY_OCR_IMG_LIST",
        params
      });
    },
    queryStoreRewardList({ commit }, params) {
      return post({
        commit,
        url: `/supplierRewardRuleInfo/store_reward_list`,
        name: "QUERY_STORE_REWARD_LIST",
        params
      });
    },
    submitDeclareImg({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/declare/update`,
        name: "SUBMIT_DECLARE_IMG",
        params
      });
    },
    queryStoreShopInfoListNew({ commit }, params) {
      return post({
        commit,
        url: `/storeBasicInfo/findStoreShopInfoListByStoreList`,
        name: "QUERY_STORE_SHOP_INFO_LIST_NEW",
        params
      });
    },
    editStoreName({ commit }, params) {
      return post({
        commit,
        url: `/storeBasicInfo/editStoreName`,
        name: "EDIT_STORE_NAME",
        params
      });
    },
    editSupplierAccountType({ commit }, params) {
      return post({
        commit,
        url: `/storeBasicInfo/editStoreAccountType`,
        name: "EDIT_SUPPLIER_ACCOUNT_TYPE",
        params
      });
    },
    queryAgencyShopList({ commit }, params) {
      return post({
        commit,
        url: `/store/supplierAgencyRel/queryAgencyShopList`,
        name: "QUERY_AGENCY_SHOP_LIST",
        params
      });
    },
    queryAgencyNotRelShopList({ commit }, params) {
      return post({
        commit,
        url: `/store/supplierAgencyRel/findAgencyNotRelShopList`,
        name: "QUERY_AGENCY_NOT_REL_SHOP_LIST",
        params
      });
    },
    agencyShopDel({ commit }, params) {
      return post({
        commit,
        url: `/store/supplierAgencyRel/agencyShopDel`,
        name: "AGENCY_SHOP_DEL",
        params
      });
    },
    agencyShopSave({ commit }, params) {
      return post({
        commit,
        url: `/store/supplierAgencyRel/relShopSave`,
        name: "AGENCY_SHOP_SAVE",
        params
      });
    },
    queryAgencyRelShopListBox({ commit }, params) {
      return post({
        commit,
        url: `/store/supplierAgencyRel/queryAgencyRelShopListBox`,
        name: "QUERY_AGENCY_REL_SHOP_LIST_BOX",
        params
      });
    },
    querySupplierReceiptList({ commit }, params) {
      return post({
        commit,
        url: `/notice/supplierReceiptDeclareBillNotice/queryPageList`,
        name: "QUERY_SUPPLIER_RECEIPT_LIST",
        params
      });
    },
    addSupplierReceipt({ commit }, params) {
      return post({
        commit,
        url: `/notice/supplierReceiptDeclareBillNotice/add`,
        name: "ADD_SUPPLIER_RECEIPT",
        params
      });
    },
    editSupplierReceipt({ commit }, params) {
      return post({
        commit,
        url: `/notice/supplierReceiptDeclareBillNotice/edit`,
        name: "EDIT_SUPPLIER_RECEIPT",
        params
      });
    },
    queryByIdSupplierReceipt({ commit }, params) {
      return post({
        commit,
        url: `/notice/supplierReceiptDeclareBillNotice/queryById`,
        name: "QUERY_BY_ID_SUPPLIER_RECEIPT",
        params
      });
    },
    findStorePageByType({ commit }, params) {
      return post({
        commit,
        url: `/storeBasicInfo/findStorePageByType`,
        name: "FIND_STORE_PAGE_BY_TYPE",
        params
      });
    },
  }
};

export default merchants;
